
SJ.VariableSlider = 
class {
  constructor(varName, upd) {
    this.varName = varName;
    this.slider = select("#id-" + varName);

    this.update = upd || (() => {
      SJ.V[this.varName] = Number(this.slider.value());
    });
  }

  setDefaultValue() {
    this.slider.value(SJ.V[this.varName]);
  }

}

SJ.VariableSlidersManager =
class {
  constructor() {
    const gravitySlider = new SJ.VariableSlider("gravity")
    gravitySlider.update = () => {
      SJ.world.gravity.y = Number(gravitySlider.slider.value());
    }

    const airFrictionSlider = new SJ.VariableSlider("airFriction")
    airFrictionSlider.update = () => {
      SJ.jumper.body.frictionAir = Number(airFrictionSlider.slider.value());
    }

    this._sliders = [
      new SJ.VariableSlider("padFriction"),
      airFrictionSlider,
      new SJ.VariableSlider("liftForce"),
      new SJ.VariableSlider("windLiftForce"),
      new SJ.VariableSlider("airRotateForce"),
      new SJ.VariableSlider("airMinForce"),
      new SJ.VariableSlider("airMaxForce"),
      new SJ.VariableSlider("zeroLiftForceAngleCorrection"),
      new SJ.VariableSlider("liftForceAngle"),
      new SJ.VariableSlider("jumperJumpForce"),
      new SJ.VariableSlider("jumperTurnForce"),
      new SJ.VariableSlider("airDynamics"),
      new SJ.VariableSlider("goodLandingAngle"),
      new SJ.VariableSlider("maxJumpBoost"),
      new SJ.VariableSlider("boostAreaWidth"),
      new SJ.VariableSlider("maxLandingHeight"),
    ];
  }

  setDefaultValues() {
    this._sliders.forEach(slider => {
      slider.setDefaultValue();
    });
  }

  update() {
    this._sliders.forEach(slider => {
      slider.update();
    })

    console.log('%c VPAD values applied', 'color: red');
  }
}